export const Config = {
  privacyPolicy: {
    enabled: true,
    linkUrl: 'https://alliancesafetycouncil.org/privacy-policy/'
  },
  stoplight: {
    projectId: 'cHJqOjEyNTY0MQ'
  }
}